import axios from "axios";



const url=process.env.REACT_APP_BACKEND_URL;


export const PostPaymnetApproval=async(data,setErrorMessage,setErrorType,handleAlertOpen,handleClose,setIsLoading)=>{
    try {
        setIsLoading(true)
        await axios.post(`${url}/products/approve_payment`,data,{
            headers:{
                'Authorization':`Bearer ${sessionStorage.getItem('token')}`
            }
        })

        .then((res)=>{
            setIsLoading(false)
            console.log(res.data);
            setErrorMessage(res.data.message);
            setErrorType('success');
            handleAlertOpen();
            handleClose()
            setTimeout(()=>{
                window.location.reload();
            },2000)
        })
    } catch (error) {
        setIsLoading(false)
        console.log(error)
        setErrorMessage(error.response&&error.response.data.error&&typeof error.response.data.error==='string'?error.response.data.error:'Something went wrong')
        setErrorType('error');
        handleAlertOpen();
    }
}